<template>
  <div class="game">
    <div class="game__inner">
      <avl-game-menu></avl-game-menu>

      <avl-player-actions></avl-player-actions>

      <div class="game__game-id-container">
        <avl-copy-to-clipboard
          class="game__game-id"
          :label="`Copy url`"
          :text="getCurrentUrl"
        ></avl-copy-to-clipboard>

        <span class="game__separator"></span>

        <avl-copy-to-clipboard
          class="game__game-id"
          :label="`Copy pin-code: ${getGamePinCode}`"
          :text="getGamePinCode"
        ></avl-copy-to-clipboard>

        <template v-if="getIAmCreator && (gameIsStarted || gameIsFinished)">
          <span class="game__separator"></span>

          <el-button class="game__link" type="danger" @click.native="$refs.confirmationDialog.show">
            Restart
          </el-button>
        </template>
      </div>

      <div class="game__game-table-wrapper">
        <avl-game-table></avl-game-table>
      </div>
    </div>

    <avl-modal-confirmation
      ref="confirmationDialog"
      label="Are you sure you want to restart the game?"
    ></avl-modal-confirmation>

    <avl-modal-roles />

    <avl-chat
      :title="`Game: ${getGamePinCode}`"
      :messages-list="getMessages"
      :participants="getRoomUsers"
      @sendMessage="
        $store.dispatch('chat/sendMessage', {
          roomId: $route.params.id,
          message: $event,
        })
      "
    ></avl-chat>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import routerHelper from '../../services/router-helper';
  import gameMenu from './game-menu';
  import playerActions from './player-actions';
  import gameTable from './game-table';

  export default {
    computed: {
      ...mapGetters([
        'getGameShortId',
        'getGamePinCode',
        'getRenewAfter',
        'gameIsStarted',
        'gameIsFinished',
        'getIAmCreator',
      ]),
      ...mapGetters('socket', ['getRoomUsers']),
      ...mapGetters('auth', ['user']),
      ...mapGetters('chat', ['getMessages']),
      getCurrentUrl() {
        return routerHelper.generateFullPath({
          name: 'game',
          params: { id: this.$route.params.id },
        });
      },
    },
    async beforeRouteLeave(to, from, next) {
      await this.$store.dispatch('lobby/leaveRoom', { roomId: from.params.id });

      next();
    },
    components: {
      'avl-game-menu': gameMenu,
      'avl-player-actions': playerActions,
      'avl-game-table': gameTable,
    },
  };
</script>

<style lang="scss">
  .game {
    text-align: center;
    width: 100%;
    height: 100%;

    &__inner {
      display: inline-block;
      width: 100%;
    }

    &__game-id-container {
      text-align: center;
      margin-bottom: 60px;
      @include phone-lg() {
        margin-bottom: 85px;
      }
      @include tablet-sm() {
        margin-bottom: 102px;
      }
    }

    &__game-id,
    &__link,
    &__separator {
      display: inline-block;
      vertical-align: middle;
      //
      font-size: 10px;
      @include phone-lg() {
        font-size: 14px;
      }
    }

    &__game-id {
    }

    &__link {
      padding: 0;
      border: none;
      background: none;
      //
      color: #ffffff;
    }

    &__separator {
      width: 1px;
      height: 16px;
      background: #ffffff;
      //
      margin: 0 8px;
      @include phone-lg() {
        margin: 0 16px;
      }
    }

    &__game-table-wrapper {
      position: relative;
    }
  }
</style>
